import { ACTION_UI_MAP } from "./actionUiRegistry";

/**
 * Builder function returning an array of rendered action elements.
 * The parent component is responsible for wrapping them in a layout container.
 * @param {object}   props
 * @param {object}   props.context 
 * @param {string[]} props.orderedActionIds
 * @param {object}   props.product 
*/
export function renderActionButtons({
    context = {},
    orderedActionIds = [], 
    product, 
}) {
  return orderedActionIds
    .map((actionId) => {
      const renderAction = ACTION_UI_MAP[actionId];
      return typeof renderAction === 'function' 
        ? renderAction(product, context) 
        : null;
    })
    .filter(Boolean); 
}